import { ca } from '@cian/analytics';

export function trackSubmitButtonClick() {
  ca('eventSite', {
    action: 'click_online',
    category: 'card',
    label: 'Mortgage_calculator',
    name: 'oldevent',
    useLastProducts: true,
  });
}

export function trackDetailsButtonClick() {
  ca('eventSite', {
    action: 'click_details',
    category: 'card',
    label: 'Mortgage_calculator',
    name: 'oldevent',
    useLastProducts: true,
  });
}

export function trackLogoClick() {
  ca('eventSite', {
    action: 'click_logo',
    category: 'card',
    label: 'Mortgage_calculator',
    name: 'oldevent',
    useLastProducts: true,
  });
}
